import axios from 'axios'
import type { CustomerOrdersResponse } from '@/types/customer/Order'

export default function useCustomerOrders() {
  const fetchCustomerOrders = async (
    customerId: string,
    params: { page: number; pageSize: number }
  ): Promise<CustomerOrdersResponse> => {
    const response = await axios.get<CustomerOrdersResponse>(`/customers/${customerId}/orders`, { params })

    return response.data
  }

  return {
    fetchCustomerOrders
  }
}
